export default "__VITE_ASSET__1KKAOk0m__"